module.exports = __webpack_public_path__ + "/login_ui/img/py-c3f4c84c6762ff5c9f83c5903b71c476.svg";